import React, {
    Component
} from 'react';
import {
    registration,
    setLoadingRegistration,
    registrationSuccess,
    registrationError
} from '../../actions/AuthActions';
import {
    bindActionCreators
} from "redux";
import {
    connect
} from "react-redux";
import {
    path_login
} from '../../routes/Pathnames';
import {
    TRANSLATE_SIGN_UP,
    TRANSLATE_REGISTRATION_AGREE_WITH_TERMS
} from '../../translates/Translates';

class Registration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                email: '',
                password: '',
                password_again: ''
            },
        }
    }

    registration = () => {
        this.props.setLoadingRegistration();
        this.props.registration(this.state.form.email, this.state.form.password, this.state.form.password_again).then(() => {
            this.props.registrationSuccess();
            window.location.replace(path_login);
        }).catch(() => {
            this.props.registrationError();
        })
    }

    handleChange = (event) => {
        let field = event.target.name;
        let value = event.target.value;
        this.setState(prevState => {
            let form = prevState.form;
            form[field] = value;
            return {
                ...prevState,
                form
            }
        })
    }

    render() {
        return (
            <section id="wrapper">
                <div className="login-register">
                    <div className="login-box card">
                        <div className="card-body">
                            <form className="form-horizontal form-material" id="loginform" method="post">
                                <h3 className="p-2 rounded-title mb-3">{TRANSLATE_SIGN_UP}</h3>
                                <div className="form-group ">
                                    <div className="col-xs-12">
                                        <input className="form-control" type="text" required placeholder="Username" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="col-xs-12">
                                        <input className="form-control" type="password" required
                                            placeholder="Password" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="col-xs-12">
                                        <input className="form-control" type="password" required
                                            placeholder="Password again" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="d-flex no-block align-items-center">
                                        <div className="checkbox checkbox-primary pt-2">
                                            <input id="checkbox-signup" type="checkbox" />
                                            <label htmlFor="checkbox-signup"> {TRANSLATE_REGISTRATION_AGREE_WITH_TERMS}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group text-center mt-3">
                                    <div className="col-xs-12">
                                        <button
                                            className="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                                            type="button" onClick={this.registration}>{TRANSLATE_SIGN_UP}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setLoadingRegistration,
        registration,
        registrationSuccess,
        registrationError
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(Registration);
